import { IHierarchyAPIQuery, ISite, HierarchyLevelType } from 'common/interfaces/hierarchy-entities';
import {
  HierarchyEntityName, deleteHierarchyEntityAPICallAction, getHierarchyEntitiesAPICallAction, getHierarchyEntityAPICallAction, postHierarchyEntityAPICallAction, putHierarchyEntityAPICallAction,
} from '../helpers/hierarchy-api-actions-factory';
import { createHierarchyEntitySlice } from '../../hierarchy-state-slice-factory';

const slice = createHierarchyEntitySlice<ISite>(HierarchyLevelType.Site);

export const {
  itemsRequested: sitesRequested,
  itemsRecieved: sitesRecieved,
  itemsFailed: sitesFailed,
  itemRecieved: siteRecieved,
  itemDeleteRecieved: sitesDeleteRecieved,
} = slice.actions;

export default slice.reducer;

export const getSites = (params: Partial<IHierarchyAPIQuery>) => getHierarchyEntitiesAPICallAction(HierarchyEntityName.SITE, params, sitesRequested.type, sitesFailed.type, sitesRecieved.type);

export const getSite = (entityId: string, parentId: string) => getHierarchyEntityAPICallAction(HierarchyEntityName.SITE, { entityId, parentId }, sitesRequested.type, sitesFailed.type, siteRecieved.type);

export const createSite = (data: Partial<ISite>) => postHierarchyEntityAPICallAction(HierarchyEntityName.SITE, data, sitesRequested.type, sitesFailed.type, siteRecieved.type);

export const updateSite = (data: any) => putHierarchyEntityAPICallAction(HierarchyEntityName.SITE, data.siteid, data, sitesRequested.type, sitesFailed.type, siteRecieved.type);

export const deleteSite = (data: Partial<ISite>) => deleteHierarchyEntityAPICallAction(HierarchyEntityName.SITE, data.siteid!, sitesRequested.type, sitesFailed.type, sitesDeleteRecieved.type);
